import { z } from 'zod';

export const PRESERVED_DOCUMENT_STATUSES = ['pending', 'preserved', 'error'] as const;
export type PreservedDocumentStatus = (typeof PRESERVED_DOCUMENT_STATUSES)[number];

export const PRESERVED_DOCUMENT_TYPES = ['invoice_active', 'invoice_passive'] as const;
export type PreservedDocumentType = (typeof PRESERVED_DOCUMENT_TYPES)[number];

/** Riga `preserved_documents` come esposta dalle API `/conservazione`. */
export const PreservedDocumentDtoSchema = z.object({
  id: z.string(),
  tenant_id: z.string(),
  document_type: z.string(),
  document_ref_id: z.string().nullable(),
  document_ref_table: z.string().nullable(),
  document_ref_number: z.string().nullable(),
  document_date: z.string().nullable(),
  customer_name: z.string().nullable(),
  acube_document_uuid: z.string().nullable(),
  preservation_timestamp: z.string().nullable(),
  status: z.enum(PRESERVED_DOCUMENT_STATUSES),
  last_error_message: z.string().nullable(),
  // pg bigint → stringa sul wire
  byte_size: z.union([z.number(), z.string()]).nullable(),
  raw_payload: z.unknown(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type PreservedDocumentDto = z.infer<typeof PreservedDocumentDtoSchema>;

export const PreservedDocumentEventDtoSchema = z.object({
  id: z.string(),
  event: z.string(),
  dispatch_status: z.enum(['pending', 'done', 'failed', 'archived']),
  dispatched_at: z.string().nullable(),
  received_at: z.string(),
  error_message: z.string().nullable(),
  payload: z.unknown().optional(),
});
export type PreservedDocumentEventDto = z.infer<typeof PreservedDocumentEventDtoSchema>;

export const PreservedDocumentDetailDtoSchema = PreservedDocumentDtoSchema.extend({
  events: z.array(PreservedDocumentEventDtoSchema),
});
export type PreservedDocumentDetailDto = z.infer<typeof PreservedDocumentDetailDtoSchema>;

export const PreserveDocumentBodySchema = z.object({
  kind: z.enum(['invoice', 'supplier_invoice']),
  id: z.string().uuid(),
  force: z.boolean().optional(),
});
export type PreserveDocumentBody = z.infer<typeof PreserveDocumentBodySchema>;

/**
 * Evidenze delle righe create prima del passaggio alle API ufficiali di
 * conservazione, conservate in `raw_payload.legacy` dalla migrazione.
 */
export const PreservedDocumentLegacyEvidenceSchema = z.object({
  legacy: z.object({
    acube_document_uuid: z.string().optional(),
    receipt_url: z.string().optional(),
    preservation_hash: z.string().optional(),
    conservatore_name: z.string().optional(),
    integrity_local_hash: z.string().optional(),
    integrity_checked_at: z.string().optional(),
    integrity_mismatch: z.literal(true).optional(),
  }),
});
export type PreservedDocumentLegacyEvidence = z.infer<typeof PreservedDocumentLegacyEvidenceSchema>['legacy'];
